const Key = {
  match_making_config: {
    all: "match_making_config",
  },
  auth: {
    auth_by_token: "auth_by_token",
  },
  bloom_taxonomies: {
    all: "all_bloom_taxonomies",
  },
  career_paths: {
    all: "all_career_paths",
  },
  license: {
    all: "all_license",
  },
  partner_placement: {
    all: "all_partner_placement",
  },
  course: {
    infinite_all: "course_infinite_all",
    all: "all_course",
    detail: "detail_course",
    enrolled: "enrolled_course",
    completed: "completed_course",
    certificate: "course_certificate",
    latest: "course_latest",
    weeks: "course_weeks",
    recommendations: "course_recommendations",
    types: "course_types",
    insights: "course_insights",
    insights_detail: "course_insights_detail",
    insights_competency: "course_insights_competency",
    insights_users: "course_insights_users",
    insights_division: "course_insights_division",
  },
  skill: {
    user_skill: "USER_SKILLS",
    skills: "SKILLS",
  },
  portfolio: {
    user_portfolio: "user_portfolio",
  },
  homework_question: {
    all: "all_homework_question",
    tagging: "tagging",
    by_id: "by_id",
  },
  answer_option: {
    all: "all_answer_option",
    by_user_id: "all_answer_option_by_user_id",
  },
  answer: {
    all: "all_answer",
    by_user_id: "all_answer_by_user_id",
  },
  scorecard: {
    all: "all_scorecard",
  },
  assessment: {
    questions: "assessment_questions",
    aspects: "assessment_aspects",
    show_options: "assessment_show_options",
    results: "assessment_results",
    summary: "assessment_summary",
    items: "assessment_items",
    progress: "assessment_progress",
    score: "assessment_score",
    verify_token: "verify_token_assessment",
    verify_token_invitation: "verify_token_assessment_invitation",
    internetMeter: "internet_meter",
  },
  assignment_score: {
    all: "all_assignment_score",
    by_session_id: "all_by_session_id",
    detail: "detail_assignment_score",
    summary: "assignment_score_summary",
    chart: "assignment_score_chart",
  },
  attendance_history: {
    all: "all_attendance_history",
    by_session_id: "attendance_by_session_id",
    summary: "attendance_history_summary",
  },
  assignment_history: {
    summary: "assignment_history_summary",
    tutor: "assignment_tutor",
  },
  assignment_leaderboard: {
    all: "all_assignment_leaderboard",
  },
  leadership_experience: {
    all: "all_leadership_experience",
  },
  course_module: {
    detail: "detail_course_module",
    all: "all_course_module",
  },
  module_session: {
    all: "all_module_sessions",
    detail: "detail_module_session",
    by_course_id: "sessions_by_course_id",
  },
  bundling_codes: {
    all: "all_bundling_codes",
  },
  hiring_process: {
    all: "all_hiring_process",
  },
  education: {
    all: "all_education",
    by_id: "education_by_id",
  },
  external_courses: {
    all: "all_external_courses",
    by_id: "external_courses_by_id",
  },
  documents: {
    all: "all_documents",
    by_id: "document_by_id",
  },
  user_remarks: {
    all: "all_user_remarks",
  },
  experiences: {
    all: "all_experiences",
    by_id: "experience_by_id",
  },
  user: {
    all: "all_users",
    by_role: "user_by_role",
    by_id: "user_by_id",
    by_id_and_current_user_state: "by_id_and_current_state",
    career_path_enrolled_product: "user_career_path_enrolled_product",
    recommendation: "user_recommendation",
    talent_pool: "user_talent_pool",
    identify: "identify_user",
  },
  final_scoring: {
    by_course_id: "final_scoring_by_course_id",
  },
  final_project_submission: {
    by_module_session_id: "final_project_submission_by_module_session_id",
  },
  behaviour_scorings: {
    by_mentoring_group_id: "behaviour_scorings_by_mentoring_group_id",
    by_course_id: "mentoring_groups_by_course_id",
    summary: "behaviour_scorings_summary",
  },
  scoring_templates: {
    all: "all_scoring_templates",
    by_scoring_template_id: "behaviours_by_scoring_template_id",
  },
  user_courses: {
    enrolled: "enrolled_user_courses",
    detail: "detail_user_courses",
  },
  competencies: {
    all: "all_competencies",
    sub_competency_count: "sub_competency_count_competencies",
  },
  industry_categories: {
    all: "all_industry_categories",
  },
  talents_list: {
    all: "all_talents_list",
  },
  student_list: {
    by_mentoring_group_id: "student_list_by_mentoring_id",
  },
  sub_competencies: {
    all: "all_sub_competencies",
  },
  specialization: {
    all: "all_specialization",
  },
  surveys: {
    all: "all_surveys",
    by_survey_id: "surveys_by_survey_id",
    answers: "surveys_answers",
    ongoing: "survey_ongoing",
  },
  survey_template: {
    all: "all_survey_templates",
    detail: "detail_survey_template",
  },
  uploader: {
    get_presigned_url: "get_presigned_url",
  },
  locales: {
    all: "all_list_locales",
  },
  promo_codes: {
    all: "all_promo_codes",
    detail: "detail_promo_code",
    referral_validity: "referral_validity",
  },
  job_roles: {
    all: "all_job_roles",
  },
  job_role_groups: {
    all: "all_job_role_groups",
  },
  vwxes: {
    all: "all_vwxes",
    detail: "vwxes_detail",
    certificate_metadata: "vwxes_certificate_metadata",
    quota: "vwxes_quota",
    recommendations: "vwxes_recommendations",
    duplicates: "vwxes_duplicates",
  },
  virtual_working_experience: {
    task_detail: "vwx_task_detail",
    task_components: "vwx_task_components",
    rewards: "rewards",
  },
  user_invoices: {
    infinite_all: "infinite_all_user_invoices",
    all: "all_user_invoices",
    detail: "detail_user_invoices",
    latest: "latest_user_invoices",
    download_metadata: "user_invoices_download_metadata",
  },
  installment_requests: {
    all: "all_installment_request",
    infinite_all: "infinite_all_installment_request",
  },
  user_installments: {
    all: "user_installments",
    infinite_all: "infinite_all_user_installments",
  },
  course_rewards: {
    detail: "detail_course_rewards",
    remind_me: "remind_me_course_rewards",
  },
  user_rewards: {
    all: "all_user_rewards",
    details: "details_user_rewards",
  },
  user_imports: {
    all: "user_imports_all",
  },
  referral: {
    all: "all_referral",
  },
  education_levels: {
    all: "all_education_levels",
  },
  job_vacancies: {
    all: "all_job_vacancies",
    detail: "job_vacancies_by_id",
    statistics: "job_vacancies_statistics",
    applicant_sources: "job_vacancies_applicant_sources",
    insights: "job_vacancies_insights",
    recommendations: "job_vacancies_recommendations",
    columns_setting: "job_vacancies_column_setting",
    manage_filters: "job_vacancies_manage_filters",
    column_filters: "job_vacancies_column_filters",
    columns_setting_group: "job_vacancies_column_setting_group",
    taggings: "job_vacancies_taggings",
    partners: "job_vacancies_partners",
  },
  universities: {
    all: "all_universities",
  },
  locations: {
    all: "all_locations",
  },
  university_majors: {
    all: "all_university_majors",
  },
  user_career_paths: {
    all: "all_user_career_paths",
    percentile_rank: "user_percentile_rank",
    recommended_talents: "recommended_talents",
  },
  user_vwx_tasks: {
    summary: "user_vwx_tasks_sumamry",
  },
  skills: {
    all: "all_skills",
  },
  partners: {
    all: "all_partners",
    recruiters: "partner_recruiters",
  },
  provinces: {
    all: "all_provinces",
  },
  job_guarantees: {
    all: "all_job_guarantees",
  },
  user_vwxes: {
    all: "all_user_vwxes",
    competencies: "user_vwxes_competencies",
    talent_pool: "user_vwxes_talent_pool",
    saved_candidate_count: "user_vwxes_saved_candidates_count",
    download_cv_metadata: "talent_cv_download_metadata",
    talent_access_token: "talent_access_token",
    talent_count: "talent_count",
    talent_vip_count: "talent_vip_count",
    all_talent_count: "all_talent_count",
  },
  achievements: {
    by_id: "achievements_by_id",
  },
  talent_pools: {
    download: "talent_pools_download",
  },
  partner_teams: {
    all: "all_partner_team",
  },
  counseling: {
    detail: "detail_counseling",
  },
  organization: "organization",
  final_scoring_metrics: {
    all: "all_final_scoring_metrics",
  },
  user_group: {
    all: "all_user_group",
    filtered: "filterd_user_group",
    statistic: "statistic_user_group",
    search: "search_user",
  },
  open_ai: {
    list_chat: "list_chat_open_ai",
    list_messages: "list_messages_open_ai",
    chat_detail: "chat_detail_open_ai",
    assistant: "assistant_open_ai",
  },
  user_notifications: {
    all: "all_notifications",
  },
  features: {
    all: "all_features",
    latest: "latest_feature",
    config: "features_config",
  },
  user_feature_onboardings: {
    detail: "user_feature_onboardings_by_id",
  },
  user_job_vacancies: {
    all: "all_user_job_vacancies",
    funnel_recruitment: "user_job_vacancies_funnel_recruitment",
    comparison: "user_job_vacancies_comparison",
    histories: "user_job_vacancies_histories",
    applied_vacancies: "user_job_vacancies_applied_vacancies",
    submission_pipelines: "user_job_vacancies_submission_pipelines",
    page_info: "user_job_vacancies_page_info",
    hris_sync: "user_job_vacancy_hris_sync",
    bulk_updates: "user_job_vacancies_bulk_updates",
    bulk_updates_detail: "user_job_vacancies_bulk_updates_detail",
    mutation: { general: "mutate_user_job_vacancies_general" },
  },
  invite_and_assess: {
    all: "all_invite_and_assess",
    detail: "invite_and_assess_detail",
  },
  assessment_item: {
    all: "all_assessment_item",
    config: "assessment_item_config",
  },

  biodata_fulfillment: {
    by_id: "biodata_fulfillment_by_id",
  },
  web_configs: {
    all: "web_config_all",
  },
  digital_cv: {
    address: "digital_cv_address",
    settings: "digital_cv_settings",
    visitor_count: "digital_cv_visitor_count",
    list_validated: "digital_cv_list_validated",
    list_not_validated: "digital_cv_list_not_validated",
    similar_role: "similar_role",
    progress: "digital_cv_progress",
  },
  jap_campus: {
    check_status: "jap_campus_check_status",
    period: "jap_campus_period",
  },
  surveys_v2: {
    all: "survey_all",
  },
  company_assessment: {
    by_vacancy: "company_assessments_by_vacancy",
    users: "company_assessment_users",
    assessment: "company_assessments",
    templates: "company_assessment_templates",
    user_scores: "company_assessment_user_scores",
    user_assessments: "user_assessments",
    report: "company_assessment_report",
    integrated_pipeline: "company_assessment_integrated_pipeline",
  },
  public_certificate: {
    all: "all_public_certificate",
  },
  iq_test: {
    stimulus_all: "iq_test_stimulus",
    stimulus_detail: "iq_test_stimulus_detail",
  },
  proctoring: {
    all: "proctoring_all",
    logs: "proctoring_logs",
  },
  user_course_review: {
    all: "user_course_review_all",
    statistic: "user_course_review_statistic",
    by_id: "user_course_review_by_id",
  },
  vacancy_questions: {
    question: "vacancy_questions",
    answer: "vacancy_answers",
    options: "vacancy_options",
  },
  hiring_pipelines: {
    all: "hiring_pipelines_all",
    column_filters: "hiring_pipelines_column_filters",
    another_source: "hiring_pipelines_another_source",
  },
  user_hiring_pipelines: {
    all: "user_hiring_pipelines_all",
    feedbacks: "user_hiring_pipelines_feedbacks",
  },
  user_tokens: {
    upload_identity: "upload_identity",
    assessment_upload_identity: "assessment_upload_identity",
  },
  share_vacancy_token: {
    manage_vacancy: "share_manage_vacancy_token",
  },
  mail_templates: {
    all: "mail_templates_all",
    detail: "mail_templates_detail",
  },
  organization_experience: {
    all: "all_organization_experience",
  },
  feedback: {
    templates: "feedback_templates",
  },
  paragon: {
    dashboard_stats: "paragon_dashboard_stats",
    chart_users: "paragon_chart_users",
    completion_rate: "paragon_completion_rate",
    most_active_team: "paragon_most_active_team",
  },
  super_admin: {
    partners: "super_admin_partners",
  },
  blacklists: {
    list: "blacklists_list",
    history: "blacklist_history",
  },
  internal_mobility_candidates: {
    list: "internal_mobility_candidates_list",
    invitation_preview: "internal_mobility_candidates_invitation_preview",
  },
  job_application_restrictions: "job_application_restrictions",
  applicant_exports: {
    status: "applicant_export_status",
  },
  articles: {
    all: "all_articles",
    detail: "detail_article",
    managed: "all_managed_articles",
    trash: "all_trash_articles",
  },
  talentlytica: {
    projects: "talentlytica_projects",
    vacancy_setting: "talentlytica_vacancy_setting",
  },
  matchmaking_config: {
    tenant: "tenant_matchmaking_config",
  },
};

export default Key;
